module.exports = __webpack_public_path__ + "media/images/cardiff_ctr-c5e35fe4594c5965da6d6259b5ce2468.jpg";